import { render, staticRenderFns } from "./echart_5.vue?vue&type=template&id=1bddb1b5&scoped=true"
import script from "./echart_5.vue?vue&type=script&lang=js"
export * from "./echart_5.vue?vue&type=script&lang=js"
import style0 from "./echart_5.vue?vue&type=style&index=0&id=1bddb1b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bddb1b5",
  null
  
)

export default component.exports